import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import BootstrapVue from 'bootstrap-vue'
import VueTextareaAutosize from 'vue-textarea-autosize'
import UUID from 'vue-uuid'
import NProgress from 'nprogress'
import VueAnalytics from 'vue-analytics'
// import VueDrift from 'vue-drift'
import VScrollLock from 'v-scroll-lock'

import '@/assets/icons'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'nprogress/nprogress.css'
import '@/assets/css/main.css'

NProgress.configure({ showSpinner: false })

Vue.use(BootstrapVue)
Vue.use(VueTextareaAutosize)
Vue.use(UUID)
Vue.use(VScrollLock)

const isProd = process.env.VUE_APP_NODE_ENV

Vue.use(VueAnalytics, {
  id: 'UA-132034839-5',
  router,
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
